"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToDomainRefill = mapToDomainRefill;
exports.mapToDomainRefillDetail = mapToDomainRefillDetail;
function mapToDomainRefill(dto) {
    return {
        micronMachineId: dto.micronMachineId,
        clubId: dto.clubId,
        messageId: dto.messageId,
        status: dto.status,
        createTime: dto.createTime,
        username: dto.username,
    };
}
function mapToDomainRefillDetail(dto) {
    return {
        refill: mapToDomainRefill(dto.refill),
        aisleRefills: dto.aisleRefills.map((aisle) => ({
            aisleName: aisle.aisleName,
            aisleCode: aisle.aisleCode,
            price: aisle.price,
            oldStock: aisle.oldStock,
            newStock: aisle.newStock,
            maxStock: aisle.maxStock,
            micronProductId: aisle.micronProductId,
            productName: aisle.productName,
            productCode: aisle.productCode,
            productCustomCode: aisle.productCustomCode,
            currency: aisle.currency,
            imgUrl: aisle.imgUrl,
            thumbnailUrl: aisle.thumbnailUrl,
            isEnable: aisle.isEnable,
            isBroken: aisle.isBroken,
            weight: aisle.weight,
        })),
    };
}
